import { createContext } from 'react';

import { TranslatorContextValue } from './types';

const defaultContext = {
    t: () => '',
};

export const TranslatorContext = createContext<TranslatorContextValue>(defaultContext);
